(function () {
  function dotsPlugin(slider) {
  var dots
  var count = 0

  function createDiv(className) {
    var div = document.createElement("div")
    className.split(" ").forEach(function (name) {
      div.classList.add(name)
    })
    return div
  }

  function removeEl(el) {
    if (el && el.parentNode) el.parentNode.removeChild(el)
  }

  function slidesPerView(details) {
    if (details && details.slides && details.slides[0] && details.slides[0].size) {
      var per = 1 / details.slides[0].size
      return Math.max(1, Math.round(per))
    }
    return 1
  }

  function pages(details) {
    var spv = slidesPerView(details)
    return Math.max(1, details.slides.length - spv + 1)
  }

  function build() {
    var details = slider.track.details
    if (!details) return

    count = pages(details)

    dots = createDiv("team-dots")
    for (var i = 0; i < count; i++) {
      ;(function (idx) {
        var dot = createDiv("team-dot")
        dot.addEventListener("click", function () {
          slider.moveToIdx(idx)
        })
        dots.appendChild(dot)
      })(i)
    }

    slider.container.insertAdjacentElement("afterend", dots)
  }

  function update() {
    var details = slider.track.details
    if (!details || !dots) return

    var spv = slidesPerView(details)
    var total = Math.max(1, details.slides.length - spv + 1)
    var current = Math.min(details.rel, total - 1)

    Array.from(dots.children).forEach(function (dot, idx) {
      if (idx === current) dot.classList.add("is-active")
      else dot.classList.remove("is-active")
    })
  }

  slider.on("created", function () {
    build()
    update()
  })

  slider.on("updated", function () {
    if (dots) removeEl(dots)
    build()
    update()
  })

  slider.on("optionsChanged", function () {
    if (dots) removeEl(dots)
    build()
    update()
  })

  slider.on("slideChanged", function () {
    update()
  })

  slider.on("destroyed", function () {
    removeEl(dots)
  })
}


  function enable(el) {
    if (el._keen) return

    el.classList.add("keen-slider")

    el.querySelectorAll("[data-team-slide]").forEach(function (slide) {
      slide.classList.add("keen-slider__slide")
    })

    el._keen = new window.KeenSlider(
      el,
      {
        loop: false,
        rubberband: true,
        slides: {
          perView: 2,
          spacing: 4
        }
      },
      [dotsPlugin]
    )
  }

  function disable(el) {
    if (el._keen) {
      el._keen.destroy()
      el._keen = null
    }

    el.classList.remove("keen-slider")

    el.querySelectorAll("[data-team-slide]").forEach(function (slide) {
      slide.classList.remove("keen-slider__slide")
    })

    var nextDots = el.nextElementSibling
    if (nextDots && nextDots.classList.contains("team-dots")) {
      nextDots.parentNode.removeChild(nextDots)
    }
  }

  function sync(root) {
    var isMobile = window.matchMedia("(max-width: 749px)").matches
    ;(root || document).querySelectorAll("[data-team-slider]").forEach(function (el) {
      if (isMobile) enable(el)
      else disable(el)
    })
  }

  function whenKeenReady(cb) {
    if (window.KeenSlider) cb()
    else setTimeout(function () { whenKeenReady(cb) }, 50)
  }

  function init() {
    whenKeenReady(function () {
      sync()
      window.addEventListener("resize", function () {
        sync()
      })
    })
  }

  document.addEventListener("DOMContentLoaded", init)

  document.addEventListener("shopify:section:load", function (e) {
    whenKeenReady(function () {
      sync(e.target)
    })
  })

  document.addEventListener("shopify:section:unload", function (e) {
    e.target.querySelectorAll("[data-team-slider]").forEach(function (el) {
      disable(el)
    })
  })
})()
